import orderGiftCard from "./order-gift-card";
import setGiftCard from "./set-card";

setGiftCard('.btn-buy-gift-card');

const form = document.querySelector('#gift-card-order-form') as HTMLFormElement | null;

if(form != null){
    
    const modOrder = new orderGiftCard(
        '#gift-card-order-form',
        '#btn-form-buy-gift-card'
    );
    
    modOrder.validateForm();

}
    
